export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-6 md:p-10 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                随时随地 畅享高清追剧
              </h2>
              <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                桃子影院全面适配手机、平板与电脑，无需下载APP，浏览器打开即享蓝光4K画质。支持后台播放与画中画模式，让追剧融入生活的每一个瞬间。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <div className="flex items-center gap-2 bg-background-50/15 border border-background-50/25 rounded-md px-4 py-2.5 cursor-pointer">
                  <div className="w-5 h-5 flex items-center justify-center text-background-50">
                    <i className="ri-smartphone-line"></i>
                  </div>
                  <span className="text-sm text-background-50 font-medium whitespace-nowrap">手机端访问</span>
                </div>
                <div className="flex items-center gap-2 bg-background-50/15 border border-background-50/25 rounded-md px-4 py-2.5 cursor-pointer">
                  <div className="w-5 h-5 flex items-center justify-center text-background-50">
                    <i className="ri-computer-line"></i>
                  </div>
                  <span className="text-sm text-background-50 font-medium whitespace-nowrap">电脑端访问</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 w-full lg:w-72 p-6 md:p-0">
              <div className="bg-background-50/10 backdrop-blur-sm rounded-lg p-6 mx-auto max-w-xs">
                <div className="w-32 h-32 mx-auto bg-background-50 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-movie-2-line text-5xl text-primary-500"></i>
                </div>
                <p className="text-center text-sm text-background-50/80">浏览器输入网址<br/>即刻开始观影</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}